import { render } from "./Player.vue?vue&type=template&id=42145154&scoped=true&ts=true"
import script from "./Player.vue?vue&type=script&lang=ts"
export * from "./Player.vue?vue&type=script&lang=ts"

import "./Player.vue?vue&type=style&index=0&id=42145154&scoped=true&lang=css"

import exportComponent from "/Users/pkraeutli/development/reca/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42145154"]])

export default __exports__